import Container from "../../../components/element/container";
import { MDBModalBody } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../../components/element/icon";
import FullModal from "../../../components/modal/full.modal";
import useRequireAuth from "../../../components/hook/use.require.auth";
import { closeReferralModal } from "../../../redux/reducer/modal.reducer";

export default function ReferAndEarnModal({ onShare, onCopyLink }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { requireAuth } = useRequireAuth();
  const { isOpenReferralModal } = useSelector((state) => state.modal);
  const close = () => dispatch(closeReferralModal());

  const steps = [
    {
      icon: "solar:link-linear",
      title: "Share Car Link",
      subtitle: "to your friend",
    },
    {
      icon: "solar:card-2-linear",
      title: "Pay & Reserve",
      subtitle: "the Car",
    },
    {
      icon: "streamline-ultimate:car-actions-check-1",
      title: "Complete Purchase",
      subtitle: "and earn RM500",
    },
  ];

  return (
    <FullModal
      independent
      show={isOpenReferralModal}
      close={close}
      showCloseButton
      centered
      screenSize="lg"
      className="product-action-modal referral-modal overflow-hidden"
      dialogClassName="action-modal-dialog referral-dialog"
      contentClassName="action-modal-content referral-content"
      content={
        <MDBModalBody className="action-modal-body referral-body">
          <h2 id="referral-title">{t("Refer and Earn")}</h2>
          <h3>
            {t("Earn")} <span>RM 500 Cash</span> {t("by Referring a Friend")}
          </h3>
          <ul className="referral-copy">
            <li>
              {t(
                "Earn RM 500 in Cash for each person you refer who takes delivery.",
              )}
            </li>
            <li>
              {t(
                "Who complete purchase a car using your referral link will receive RM 500 off the purchase price.",
              )}
            </li>
          </ul>
          <Container tag="div" className="modal-section-heading">
            <span />
            <h3>{t("How it works")}</h3>
            <span />
          </Container>
          <Container tag="div" className="referral-steps">
            {steps.map((step, index) => (
              <article className="referral-step" key={step.title}>
                <span className="_label referral-step-number">{index + 1}</span>
                <Icon icon={step.icon} className="referral-step-icon" />
                <p>
                  <span className="_label referral-step-title">
                    {t(step.title)}
                  </span>
                  <span>{t(step.subtitle)}</span>
                </p>
              </article>
            ))}
          </Container>
          <button
            type="button"
            className="action-modal-primary"
            onClick={() => {
              requireAuth(onShare, { modal: "referral" });
              // close();
            }}
          >
            {t("Share with Friends")}

          </button>
          <button
            type="button"
            className="referral-copy-link"
            onClick={() => requireAuth(onCopyLink, { modal: "referral" })}
          >
            <Icon icon="fad:copy" />
            {t("Copy link")}
          </button>
        </MDBModalBody>
      }
    />
  );
}
